import React from 'react';
import IncomingCallModal from './IncomingCallModal';
import OutgoingCallModal from './OutgoingCallModal';
import CallView from './CallView';

// Orquestador unico montado en App. Decide que renderizar segun el estado del CallContext.
export default function CallOverlay() {
    return (
        <>
            <IncomingCallModal />
            <OutgoingCallModal />
            <CallView />
        </>
    );
}
